import { Typography, Card, Tag, Empty, Tree } from 'antd';
import { t } from '../../i18n/i18n';
import { getDataType } from '../../utils/arrayUtils';
import { TRIGGER_TEMPLATES } from '../../constants/alkymation';
import './NodeInputPanel.scss';

const { Title, Text } = Typography;

const NodeInputPanel = ({ previousNode, previousNodeOutputData }) => {
  // Mapping for field display names
  const getFieldDisplayName = (key) => {
    const isPreviousNodeScreeningWebhook =
      previousNode?.templateId === TRIGGER_TEMPLATES.WEBHOOK_SCREENING_COMPLETE ||
      previousNode?.template?.templateId === TRIGGER_TEMPLATES.WEBHOOK_SCREENING_COMPLETE;

    if (isPreviousNodeScreeningWebhook && key === 'screeningScore') {
      return t('SCREENING_DATA_OPTION_SCORE');
    }

    return key;
  };

  const convertToTreeData = (data, parentKey = 'root') => {
    if (!data) return [];

    if (typeof data === 'object' && !Array.isArray(data)) {
      return Object.keys(data).map((key) => {
        const value = data[key];
        const nodeKey = `${parentKey}-${key}`;
        const dataType = getDataType(value);
        const displayName = getFieldDisplayName(key);

        if (typeof value === 'object' && value !== null) {
          return {
            title: (
              <div className="tree-node-title">
                <Text strong>{displayName}</Text>
                <Tag color="blue" size="small">
                  {dataType}
                </Tag>
              </div>
            ),
            key: nodeKey,
            children: convertToTreeData(value, nodeKey),
          };
        }

        return {
          title: (
            <div className="tree-node-title">
              <Text>{displayName}:</Text>
              <div style={{ display: 'flex' }}>
                <Text code className="ml-2">
                  {String(value)}
                </Text>
                <Tag color="green" size="small" className="ml-2">
                  {dataType}
                </Tag>
              </div>
            </div>
          ),
          key: nodeKey,
        };
      });
    }

    if (Array.isArray(data)) {
      return data.map((item, index) => {
        const nodeKey = `${parentKey}-${index}`;
        const dataType = getDataType(item);

        if (typeof item === 'object' && item !== null) {
          return {
            title: (
              <div className="tree-node-title">
                <Text strong>[{index}]</Text>
                <Tag color="blue" size="small">
                  {dataType}
                </Tag>
              </div>
            ),
            key: nodeKey,
            children: convertToTreeData(item, nodeKey),
          };
        }

        return {
          title: (
            <div className="tree-node-title">
              <Text>[{index}]:</Text>
              <Text code className="ml-2">
                {String(item)}
              </Text>
            </div>
          ),
          key: nodeKey,
        };
      });
    }

    return [];
  };

  const treeData = convertToTreeData(previousNodeOutputData);

  if (!previousNode) {
    return (
      <div className="node-input-panel">
        <Card className="input-panel-card">
          <Empty
            description={t('ALKYMATION_NO_PREVIOUS_NODE')}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </Card>
      </div>
    );
  }

  return (
    <div className="node-input-panel">
      <Card className="input-panel-card">
        <div className="panel-header">
          <div className="d-flex align-items-center mb-3">
            <img
              className="node-icon-small"
              src={`data:image/svg+xml;base64,${btoa(previousNode.template?.icon)}`}
              style={{
                backgroundColor: previousNode.template?.color || '#666',
                padding: '4px 8px',
                borderRadius: '4px',
                color: 'white',
                marginRight: '8px',
              }}
              alt=""
            />
            <div>
              <Title level={5} className="mb-0">
                {t('ALKYMATION_INPUT_DATA')}
              </Title>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {t(previousNode.name)}
              </Text>
            </div>
          </div>
        </div>

        <div className="panel-content">
          {!previousNodeOutputData ? (
            <Empty
              description={t('ALKYMATION_NO_EXECUTION_DATA')}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          ) : (
            <div className="data-tree">
              <Text type="secondary" className="d-block mb-2">
                {t('ALKYMATION_AVAILABLE_DATA')}:
              </Text>
              <Tree treeData={treeData} defaultExpandAll showLine className="output-tree" />
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default NodeInputPanel;
